import { computed, ComputedRef } from 'vue'
import { getDirectory } from '@/directory'

interface FlowCapabilities {
  allowsRoutes: boolean
  allowsSendToReview: boolean
  allowsFamiliarization: boolean
}

interface FlowType {
  id: string
  name: string
  capabilities: FlowCapabilities
}

interface DocumentFlowHelpers {
  allowsRoutes: ComputedRef<boolean>
  allowsSendToReview: ComputedRef<boolean>
  allowsFamiliarization: ComputedRef<boolean>
}

const defaultCapabilities: FlowCapabilities = {
  allowsRoutes: true,
  allowsSendToReview: false,
  allowsFamiliarization: true,
}

export function useDocumentFlow(getFlowType: () => string | null | undefined): DocumentFlowHelpers {

  const capabilities = computed<FlowCapabilities>(() => {
    const flowType = getFlowType()
    if (!flowType) return defaultCapabilities

    const flows = getDirectory('docTypeFlowTypes') as FlowType[]
    const flow = flows?.find(f => f.id === flowType)

    return flow?.capabilities ?? defaultCapabilities
  })

  return {
    allowsRoutes: computed(() => capabilities.value.allowsRoutes),
    allowsSendToReview: computed(() => capabilities.value.allowsSendToReview),
    allowsFamiliarization: computed(() => capabilities.value.allowsFamiliarization),
  }
}
